export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters)
  }
}

export const toAnalyticsItem = (item) => {
  const price = Number(item.price ?? 0)
  const discountedPrice = Number(item.discprice ?? price)

  return {
    item_id: String(item.id || item._id || item.upc || ''),
    item_name: item.item || item.name || '',
    item_brand: item.manufacturer || '',
    item_category: item.subname || '',
    price: discountedPrice,
    quantity: Number(item.quantity ?? item.saleqty ?? 1),
    discount: Math.max(0, price - discountedPrice)
  }
}
